const TIME_FIELDS = [
  'createdAt',
  'created_at',
  'activityAt',
  'incidentDate',
  'requestDate',
  'start',
  'updatedAt',
];

function timeValue(row) {
  if (!row || typeof row !== 'object') return 0;
  for (let i = 0; i < TIME_FIELDS.length; i += 1) {
    const raw = row[TIME_FIELDS[i]];
    if (raw == null || raw === '') continue;
    const ms = Date.parse(raw);
    if (!Number.isNaN(ms)) return ms;
    if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  }
  return 0;
}

function numericId(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const text = String(value).trim();
  if (!text || text.includes('-')) return null;
  const n = Number(text);
  return Number.isFinite(n) ? n : null;
}

/**
 * Newest record first (page 1). Prefers createdAt / similar dates, then numeric id.
 */
export function sortRowsNewestFirst(rows) {
  if (!Array.isArray(rows) || rows.length < 2) {
    return Array.isArray(rows) ? rows : [];
  }
  return [...rows].sort((a, b) => {
    const timeDiff = timeValue(b) - timeValue(a);
    if (timeDiff !== 0) return timeDiff;
    const aId = numericId(a?.id);
    const bId = numericId(b?.id);
    if (aId != null && bId != null && aId !== bId) return bId - aId;
    const aSoft = numericId(a?.softwareId);
    const bSoft = numericId(b?.softwareId);
    if (aSoft != null && bSoft != null && aSoft !== bSoft) return bSoft - aSoft;
    return String(b?.id ?? '').localeCompare(String(a?.id ?? ''), undefined, { numeric: true });
  });
}

export default sortRowsNewestFirst;
